import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage to every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("nexa_admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// On 401 from admin endpoints, clear stored token
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (
            err?.response?.status === 401 &&
            err?.config?.url?.includes("/admin")
        ) {
            localStorage.removeItem("nexa_admin_token");
        }
        return Promise.reject(err);
    },
);

// Public
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchTeam = () => api.get("/team").then((r) => r.data);

// Auth
export const adminLogin = (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);

// Admin
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const adminUpdateLead = (id, body) => api.patch(`/admin/leads/${id}`, body).then((r) => r.data);
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminBookings = () => api.get("/admin/bookings").then((r) => r.data);
export const adminUpdateBooking = (id, body) =>
    api.patch(`/admin/bookings/${id}`, body).then((r) => r.data);
export const adminDeleteBooking = (id) =>
    api.delete(`/admin/bookings/${id}`).then((r) => r.data);
export const adminNewsletter = () => api.get("/admin/newsletter").then((r) => r.data);

// Token helpers
export const setAdminToken = (t) => localStorage.setItem("nexa_admin_token", t);
export const getAdminToken = () => localStorage.getItem("nexa_admin_token");
export const clearAdminToken = () => localStorage.removeItem("nexa_admin_token");
